/**
 * @license CKCode
 * Copyright 2023 CourseKata
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import { __decorate } from "tslib";
import { customElement } from "lit/decorators.js";
import { styles as feedbackStyles } from "./internal/feedback.css.js";
import { MarkdownFeedbackArea } from "./internal/markdown-feedback-area.js";
import { styles } from "./internal/styles.css.js";
let CKFeedbackArea = class CKFeedbackArea extends MarkdownFeedbackArea {
};
CKFeedbackArea.styles = [feedbackStyles, styles];
CKFeedbackArea = __decorate([
    customElement("ck-feedback-area")
], CKFeedbackArea);
export { CKFeedbackArea };
//# sourceMappingURL=feedback-area.js.map